module.exports = __webpack_public_path__ + "img/servicii_profesioniste.13e8ca07.svg";